import { render, staticRenderFns } from "./IntouchEdit.vue?vue&type=template&id=26e71423&"
import script from "./IntouchEdit.vue?vue&type=script&lang=js&"
export * from "./IntouchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports